import { RootState } from '../../Presentation/store';

export const selectAuth       = (s: RootState) => s.auth;
export const selectAuthToken  = (s: RootState) => s.auth.access;
export const selectUser       = (s: RootState) => s.auth.user;
export const selectAuthLoading= (s: RootState) => s.auth.loading;